import { REDUX_ACTIONS, GAME_ID } from 'a/pickyGoblins/data/constants';

const initState = {
  pageX: 0,
  pageY: 0,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
};

const screenPositionReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    // change screen according to action payload
    case REDUX_ACTIONS.SAVE_SCREEN_COORDINATES:
      return {
        ...state,
        pageX: payload.pageX,
        pageY: payload.pageY,
        width: payload.width,
        height: payload.height,
        x: payload.x,
        y: payload.y,
      };

    default:
      return state;
  }
};

export default screenPositionReducer;
